import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { PlatformService } from 'src/app/singleton-services/platform.service'

@Component({
  selector: 'flo-race-monitor',
  template: ` <div class="d-flex flex-column gap-3 w-100 h-100 d-none d-lg-block" *ngIf="!!srcUrls">
    <iframe
      *ngFor="let url of srcUrls; trackBy: trackById"
      [src]="url | floSanitizeResourceUrl"
      height="550"
      width="100%"
      style="border: 0"
      allowFullScreen="false"
    ></iframe>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RaceMonitorComponent implements OnInit {
  /**
   * These ids correspond to the external race monitor ids that we receive from core
   */
  @Input()
  public raceMonitorIds: string[]

  constructor(private ps: PlatformService) {}

  public srcUrls: string[]

  trackById = trackById

  ngOnInit() {
    if (this.ps.isBrowser) {
      /**
       * leading and trailing white space necessary here
       * for hitting the race monitor api
       *
       * Also, a RaceMonitor id cannot be removed from salesforce after it has been added.
       * In order to unassociate events, a RaceMonitor id of 0 is put in place.
       * So, if we receive a RaceMonitor id of 0, we know not to display the widget.
       */
      const filteredIds = this.raceMonitorIds.filter(id => id !== '0')

      // This prevents an error that could occur if all RM ids were to be 0
      if (filteredIds.length > 0) {
        this.srcUrls = filteredIds.map(
          id => ` //api.race-monitor.com/Timing?raceid=${id}&source=${window.location.hostname} `
        )
      }
    }
  }
}
